import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';
import { LANGS, setLanguage, type Lang } from '../../app/i18n';
import { cn } from '../../lib/cn';

// EN / FR segmented toggle with a sliding pill. Switches instantly, no reload (§17a).

export function LanguageToggle({ id = 'lang' }: { id?: string }) {
  const { t, i18n } = useTranslation();
  const current = i18n.language as Lang;
  return (
    <div
      role="radiogroup"
      aria-label={t('language.label')}
      className="relative flex h-9 items-center rounded-full border border-border bg-surface/70 p-0.5 backdrop-blur"
    >
      {LANGS.map((lang) => {
        const short = lang.startsWith('fr') ? 'fr' : 'en';
        const active = current === lang;
        return (
          <button
            key={lang}
            role="radio"
            aria-checked={active}
            aria-label={t(`language.${short}`)}
            lang={lang}
            onClick={() => setLanguage(lang)}
            className={cn(
              'relative z-10 h-full rounded-full px-3 text-xs font-bold tracking-wide transition-colors',
              active ? 'text-on-primary' : 'text-muted hover:text-text',
            )}
          >
            {active && (
              <motion.span
                layoutId={`${id}-pill`}
                className="absolute inset-0 -z-10 rounded-full bg-primary"
                transition={{ type: 'spring', stiffness: 500, damping: 34 }}
              />
            )}
            {t(`language.short.${short}`)}
          </button>
        );
      })}
    </div>
  );
}
